import React from 'react';
import { cn } from '@lux/core';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
var titlePositionMap = {
    top: 'items-start',
    bottom: 'items-end',
    center: 'items-center',
};
export var SeeAllCard = function (_a) {
    var href = _a.href, onClick = _a.onClick, _b = _a.buttontext, buttontext = _b === void 0 ? 'See All' : _b, image = _a.image, _c = _a.titlePosition, titlePosition = _c === void 0 ? 'center' : _c;
    return (React.createElement("div", { className: "relative h-full w-full" },
        React.createElement("div", { className: "absolute inset-0 z-[1] bg-cover bg-top bg-no-repeat", style: { backgroundImage: image ? "url(".concat(image, ")") : 'none' } },
            React.createElement("div", { className: "bg-function-100 h-full w-full opacity-50" })),
        React.createElement("a", { onClick: onClick, href: href, className: cn('py-m px-sm absolute z-[2] flex h-full w-full justify-center', '[&_span]:text-function-0 [&_span::after]:bg-function-0', titlePositionMap[titlePosition]) },
            React.createElement(Button, { as: "span", buttonType: ButtonType.tertiary, color: ButtonColor.dark, "data-testid": "see-all-button" }, buttontext))));
};
